/**
 * @packageDocumentation
 * @module f1/data
 */

import { TParseFormatOptions, IParseFormatRule } from '../types';

export type TValue = Record<string, unknown> | unknown[] | string;

export class PfJson implements IParseFormatRule<TValue> {
  format(options: TParseFormatOptions, value: TValue) {
    try {
      return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
    } catch (e) {
      return value + '';
    }
  }

  parse(options: TParseFormatOptions, value: string): TValue {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  defaults() {
    return {};
  }
}

export default new PfJson();
